<template>
  <div
    class="cell-wrapper"
    data-key="cell-wrapper-checkbox"
    style="padding-top: 0px; padding-bottom: 0px">
    <div class="checkbox">
      <input
        v-model="selected"
        type="checkbox"
        :disabled="disabled"
        :data-action-type="name"
        @click.stop />
    </div>
  </div>
</template>

<script setup lang="ts" generic="T extends EntityWithID">
  import { computed, onUnmounted, ref, watch } from 'vue';

  import { EntityWithID } from '@/utils/ApiUtils';

  interface IProps {
    item: T;
    selectedItems: T[];
    disabled: boolean;
    resetOnUnmount?: boolean;
    trackBy?: string;
  }

  const { item, selectedItems, disabled, resetOnUnmount = true, trackBy = 'id' } = defineProps<IProps>();

  const selected = ref(false);

  interface IEmits {
    (e: 'selection-changed', selected: boolean): void;
  }

  const emits = defineEmits<IEmits>();

  const name = computed(() => {
    if ('name' in item) {
      return item.name;
    }
    return null;
  });

  function areItemsEqual(a: T, b: T): boolean {
    // Normally, items listed in Table should have an id property, if not we fallback to compare references
    if (a[trackBy] != null && b[trackBy] != null) {
      return a[trackBy] === b[trackBy];
    }
    return a == b;
  }

  watch(
    () => selectedItems,
    () => {
      const newSelectedValue = selectedItems.some((selectedItem) => areItemsEqual(item, selectedItem));
      if (newSelectedValue != selected.value) {
        selected.value = newSelectedValue;
      }
    },
    { immediate: true },
  );

  watch(selected, (selected) => {
    emits('selection-changed', selected);
  });

  onUnmounted(() => {
    if (resetOnUnmount) {
      emits('selection-changed', false);
    }
  });
</script>
